var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid gap-8",class:_vm.$style.gridLayout},[_c('FilterSelect',{on:{"changeFilter":_vm.fetchArticles}}),_vm._v(" "),_vm._l((_vm.articles),function(article){return _c('Item',{key:article.id,attrs:{"article":article,"disciplines":_vm.articleDisciplines(article),"tags":_vm.articleTags(article)}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c80aa81","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/server/components/Articles/Widget.vue
// module id = null
// module chunks = 